<template>
  <v-card flat :loading="loading">
    <v-card-title class="subtitle-1">Invoice Communications</v-card-title>
    <v-data-table :headers="headers" :items="events" :items-per-page="25">
      <template v-slot:item.invoice="{ item }">#{{ item.Invoice && item.Invoice.localId }}</template>
      <template v-slot:item.reminderType="{ item }">{{ typeLabel(item) }}</template>
      <template v-slot:item.sentAt="{ item }">{{ item.sentAt | moment("L LT") }}</template>
      <template v-slot:item.opened="{ item }">
        <v-chip v-if="item.openCount" small color="green lighten-5" text-color="green darken-3">
          Opened {{ item.openCount }} time{{ item.openCount === 1 ? "" : "s" }}
        </v-chip>
        <v-chip v-else small>Not opened</v-chip>
        <div v-if="item.lastOpenedAt" class="caption">Last: {{ item.lastOpenedAt | moment("L LT") }}</div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import invoiceService from "../service";
export default {
  props: ["customerId"],
  data: () => ({
    loading: false,
    events: [],
    headers: [
      { text: "Invoice", value: "invoice" },
      { text: "Reminder", value: "reminderType" },
      { text: "Recipient", value: "recipient" },
      { text: "Sent", value: "sentAt" },
      { text: "Link Status", value: "opened" },
    ],
  }),
  created() { this.load(); },
  methods: {
    typeLabel(item) {
      const labels = { upcoming: "Upcoming due", due: "Due today", past_due: "Past due", manual: "Manual" };
      return `${labels[item.reminderType] || item.reminderType} #${item.reminderNumber}`;
    },
    async load() {
      this.loading = true;
      try {
        const response = await invoiceService.getEmailEvents({ CustomerId: this.customerId });
        this.events = response.data || [];
      } finally { this.loading = false; }
    },
  },
};
</script>
